import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 15v-7a3 3 0 0 1 6 0v7","key":"svg-0"}],["path",{"d":"M9 11h6","key":"svg-1"}],["path",{"d":"M5 19h14","key":"svg-2"}]]

/**
 * IconTextColor
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItdGV4dC1jb2xvciIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNOSAxNXYtN2EzIDMgMCAwIDEgNiAwdjciIC8+CiAgPHBhdGggZD0iTTkgMTFoNiIgLz4KICA8cGF0aCBkPSJNNSAxOWgxNCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/text-color
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconTextColor = createReactComponent('outline', 'text-color', 'TextColor', __iconNode);

export default IconTextColor;